import React, {PureComponent} from 'react';
import UsageChart from './UsageChart.js'
import { dateSort} from '../Report/helperfunctions'
import convertUTCToZoneTime from '../timeFunctions/TimeZone'
import {between, sanitizeDateTime} from '../timeFunctions/timeFns'
import {fetchHistory, duplicatesIndex, filterIndex, jsonToArray, mapAPIProperty} from './ChartData'
import {fixupRssiArray} from '../Report/DataHelpers'
import {siteAccessCode} from '../database/apiv2SiteAccessor'
import Popup from '../Alert/Popup.js'
import { renderLoader } from "../Loading/loading";

import './ChartModal.css'
import { singleBlock } from '../Report/HistoricalData.js';

export default class ChartModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      xaxis: [],
      secondChart: [],
      renderedSeries1: [],
      renderedXaxis: [],
      errMsg: null,
      isLoading: false,
      loader: renderLoader(),
      render: 0,
    };
    this.xaxis = []
    this.series1 = []
    this.secondChart = undefined
    this.thirdChart = undefined
    this.chartScale = 1.0;
    this.handleClose = this.handleClose.bind(this);
    this.yscale = null;
    this.dc = 4294967295
  }

  componentDidMount () {
    if (this.fetchNeeded())
      this.fetchData();
    else {
      this.chartFromProps()
    }      
  }

  async componentDidUpdate(prevProps) {
    if (prevProps?.chartProps?.rollup !== this.props?.chartProps?.rollup) {
      this.chartFromProps()
    }
    if (true === this.props.noUpdates) {    // parent handles data
      return;
    }
    if (prevProps?.startrange?.getTime() !== this.props?.startrange?.getTime() ||
        prevProps?.endrange?.getTime() !== this.props?.endrange?.getTime()) {
          this.fetchData();
    }
  }
  chartFromProps() {
    const cp = this.props.chartProps
    this.deDup(cp.label, cp.data, cp.secondChart, cp?.thirdChart);
    this.setState ({render: this.state.render+1})
  }
  fetchNeeded () {
    if (!this.props.chartProps) return true
    if ('undefined' !== typeof this.props?.singleBlock) 
      return !this.props.singleBlock 
    if (this.props?.startrange && this.props?.endrange 
        && singleBlock(this.props.startrange, this.props.endrange)) return false
    return true
  }

  computeReading (config, rawVal, sensorType) {
    if (config?.sensors?.length) {
      const index = config.sensors.findIndex(item=>item.sensor_type === sensorType)
      const num = Number(rawVal)
      if (num === -1 || num === this.dc)
        return this.dc

      const factor = config.sensors[index]?.factor ?? 1
      const imr = config.sensors[index]?.initial_meter_read ?? 0
      return Number((num * Number(factor)) + Number(imr))
    }
    return ''
  }

  async fetchData() {
    this.setState({isLoading: true});
    const radioId = this.props.chartProps.radioId;
    const apiParam = this.props.chartProps.apiParams;
    const siteId = siteAccessCode(this.props.getActiveSite())
    const objResp = await fetchHistory (radioId, this.props.startrange, this.props.endrange, apiParam, this.props, siteId);
    const jsonResponse = objResp.jsonResponse;
    const dcap_tz = sessionStorage.getItem ('site-tz');
    if ('SensorData' === apiParam && jsonResponse.data) {
      let series = [];
      let axis = [];
      let series2 = []
      const arrWorking = jsonResponse.data.data.readings;
      const byDate = dateSort(arrWorking, "read_time");
      const chartProps = this.props.chartProps
      const channels = this.mapChannelWildcards (chartProps, jsonResponse)
      const device = this.mapChannelstoDevice(channels, this.props.deviceConfig)
      byDate.forEach(reading => {
        reading.values.forEach((value, index) => {
          if (value.hasOwnProperty(channels[0])) {
            series.push(this.computeReading(device, value[channels[0]], channels[0]))
            axis.push(reading.read_time);
          }
          if (chartProps?.sensorType2 && value.hasOwnProperty(chartProps.sensorType2))
            series2.push(this.computeReading(device, value[chartProps.sensorType2], chartProps.sensorType2))
        });
      });
      axis.reverse();
      series.reverse();
      series2.reverse()
      this.deDup(axis, series, series2);
      this.setState({errMsg: objResp?.errMsg ?? '', isLoading: false});
  }
    else if (jsonResponse.data) {
      fixupRssiArray(jsonResponse.data.data.readings)
      const plotValue = this.props.chartProps.plotValue ? 
          mapAPIProperty(this.props.chartProps.plotValue) : 'BattVolt';
      // console.log(jsonResponse.data.data.readings);
      if (plotValue === 'BattVolt') {
        this.removeBogusValues(jsonResponse.data.data.readings);
      }
      else
        console.log (plotValue)

      const byDate = dateSort(jsonResponse.data.data.readings, 'ReadTime', 0)
      const axis = jsonToArray(byDate, 'ReadTime');
      axis.forEach (a => convertUTCToZoneTime(a, dcap_tz));
      const series = jsonToArray(byDate, plotValue);
      this.deDup(axis, series);
    }
  }
  mapOneChannel(channel, readings) {
    const exists = readings?.data?.data?.readings ?? []
    const reading = exists[0]?.raw_values[channel] ?? {}
    const readTypes = Object.keys (reading)
    return readTypes[0]
  }
  mapChannelWildcards(chartProps, readings) {
    let result =[] 
    result[0] = chartProps.sensorType === '*' ? this.mapOneChannel(0, readings) : chartProps.sensorType
    result[1] = chartProps.sensorType2 === '*' ? this.mapOneChannel(1, readings) : chartProps.sensorType2
    return result
  }
  mapChannelstoDevice (channels, device) {
    let result = device
    if (result?.sensor_type) {
      result.sensor_type[0] = device?.sensor_type[0] === '*' ? channels[0] : result.sensor_type[0]
      result.sensor_type[1] = device?.sensor_type[1] === '*' ? channels[1] : result.sensor_type[1]
    }
    return result
  }
  setYscale() {
    const plotValue = this.props?.chartProps?.plotValue
    if (plotValue === 'BattVolt') {
      this.yscale = {suggestedMin: 2000, suggestedMax:3000};
    }
    if (plotValue === 'LQ') {
      this.yscale = {suggestedMin: 40, suggestedMax: 100};
    }
  }
  // battery voltage is zero? no. missing also kills the chart.
  removeBogusValues (objArray) {
    for (let i = 0; i < objArray.length; ++i) {
      if (typeof(objArray[i].BattVolt) === 'undefined' || Number(objArray[i].BattVolt) <= 0) {
        objArray.splice(i, 1);
        --i;
      }
      else {
        objArray[i].BattVolt = objArray[i].BattVolt / 1000
      }
    }
  }
  deDup(xaxis, series1, secondChart, thirdChart) {  // duplicates kill charts
    const arrDuplicates = duplicatesIndex(xaxis)
    this.xaxis = filterIndex (arrDuplicates, xaxis)
    this.series1 = filterIndex (arrDuplicates, series1)
    this.secondChart = secondChart? filterIndex (arrDuplicates, secondChart) : secondChart
    this.thirdChart = thirdChart ? filterIndex(arrDuplicates, thirdChart) : thirdChart
  }
  handleClose() {
    this.props.hide();
  }

  toChart(x) {
    if (typeof x === 'number') return x
    if (typeof x === 'string')
      return parseFloat(x.replace(/,/g, ''))
    return x
  }
  intervalConsumption (readings) {
    let consumption = [0];
    if (Array.isArray(readings)) {
      readings.forEach ((reading, index) => {
        if (index > 0) {
          const p1 = Math.abs(this.toChart(reading))
          const p2 = Math.abs(this.toChart(readings[index-1]))
          if (p1===this.dc || p2 === this.dc)
            consumption.push(0)
          else
            consumption.push(Math.abs(p1 - p2))
        }
      })
    }
    return consumption;
  }

  renderTime () {
    return this.xaxis.map(item =>sanitizeDateTime(item, {zone: 'UTC'}))
  }
  rangeLimit() {
    let rangeAxis = []
    let rangeValues = []
    let secondValues = []
    let thirdValues = []
    const allTimes = this.renderTime()
    allTimes.forEach((plotTime, index) => {
      if (between (plotTime, this.props.startrange, this.props.endrange)) {
          rangeAxis.push(plotTime);
          rangeValues.push(this.toChart(this.series1[index]))
          this.updateSecondValues(secondValues, index)
          if(this.thirdChart)
            thirdValues.push(this.toChart(this.thirdChart[index]))
        }
      });
      return {times: rangeAxis, values: rangeValues, secondValues: secondValues, thirdValues: thirdValues}
  }
  updateSecondValues (arrResult, index) {
    if (this.secondChart)
      arrResult.push(this.toChart(this.secondChart[index]))
  }
  render() {
    if (!this.props.chartProps)
      return null;
    if (this.state.isLoading)
      return this.state.loader
    if (this.state.errMsg)
      return <Popup popupMsg={this.state.errMsg} />
    const renderBase = this.rangeLimit()
    const consumption = this.intervalConsumption(renderBase.values);
    const secondCons = this.intervalConsumption(renderBase.secondValues)
    const thirdCons = this.intervalConsumption(renderBase.thirdValues)
    const usage = renderBase.values;
    this.setYscale();
    const chartProps = this.props?.chartProps?.deviceMeta
    const hiddenMap = this.props?.chartProps?.hiddenMap // [3] is 2nd readings, [5] is 3rd channel
    return (
      <div className="chart-slide show"> 
       <UsageChart data={usage} series2={consumption} label={renderBase.times} seq={1}
          chartProps={chartProps} zoom={this.chartScale} yscale={this.yscale} deviceId={this.props.deviceId} />
       {renderBase.secondValues && hiddenMap && hiddenMap[3] ? 
          <UsageChart data={renderBase.secondValues} series2={secondCons} label={renderBase.times} seq={2}
            chartProps={chartProps} zoom={this.chartScale} yscale={this.yscale}  deviceId={this.props.deviceId}/>
          : null}
        {renderBase.thirdValues && hiddenMap && hiddenMap[5] ? 
          <UsageChart data={renderBase?.thirdValues} series2={thirdCons} label={renderBase.times} seq={3}
            chartProps={chartProps} zoom={this.chartScale} yscale={this.yscale}  deviceId={this.props.deviceId}/>
          : null}
       </div>
    );
  }
}
